import { Injectable } from "@angular/core";

import { environment } from "../../environments/environment";

import { Checkout } from "../models/api/checkout";
import { Contact } from "../models/api/contact";
import { Contacts } from "../models/contact.model";

import { TransferHttpService } from "@gorniv/ngx-universal";

@Injectable({
  providedIn: "root",
})
export class ApiService {
  private rootUrl = environment.API_URL;

  constructor(private http: TransferHttpService) {}

  checkout(checkout: Checkout) {
    return this.http.post(`${this.rootUrl}/checkout`, checkout);
  }

  contact(contact: Contact) {
    return this.http.post(`${this.rootUrl}/contact`, contact);
  }

  contacts(contact: Contacts) {
    return this.http.post(`${this.rootUrl}/contact`, contact);
  }

  wake() {
    return this.http.get(this.rootUrl);
  }
}
